'use client'

import { useEffect } from 'react'
import { usePathname } from 'next/navigation'
import { initIntercom } from '@/src/lib'

export const IntercomProvider = () => {
  const pathname = usePathname()

  useEffect(() => {
    initIntercom()
  }, [pathname])

  return null
}
